import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { ReportService } from 'app/services/report.service';
import { ConfigDataService } from 'app/services/config.service';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { XSD_MAPPER } from './candidateData';

@Component({
  selector: 'app-candidate-detail',
  templateUrl: './candidate-detail.component.html',
  styleUrls: ['./candidate-detail.component.css'],
})

export class CandidateDetailComponent implements OnInit, AfterViewInit {

  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  requestNumber: any;
  candidateUUID: any;
  data: any;
  temp: Boolean = false;
  protes: any;
  procedureInCorso: any;
  attiDaConservatoriaRilevati: any;
  logo:any;
  cervedPersonCGSscoreClass: any;
  cervedCensusCellByAddress: any;
  negativeEventsFlags: any;
  negativeEventsDetails: any;
  estimationAdvance: any;
  traversal: any;
  societaDetails: any[] = [];

  pieChartColors: any[] = [{
    backgroundColor: ['#152b79']
  }];
  PieChartOptions: any = {
    elements: {
      arc: {
        borderWidth: 0
      }
    },
    tooltips: {
      enabled: false
    },
  }

  // Doughnut
  public doughnutChartData: number[] = [1];
  public doughnutChartType: string = 'doughnut';

  prrObj: any;
  map = new Map<string, string>();
  doughnutTextContent: any;
  doughnutScore: number = 0;

  guageGYRColorArray = [];
  guageGYRDelimiterArray = [];

  public canvasWidthEN = 300;
  public needleValueEN = 1;
  public optionsEN = {
    hasNeedle: true,
    needleColor: '#333333',
    needleUpdateSpeed: 1000,
    arcColors: this.guageGYRColorArray,
    arcDelimiters: this.guageGYRDelimiterArray,
    rangeLabel: [],
    needleStartValue: 1
  }

  public needleValueSD = 1;
  public needleValueSR = 1;
  public needleValueScoreCGS = 1;
  pdfFileLength:number = 210;

  riskLevel: string = 'green';

  constructor(private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private configService: ConfigDataService,
    private reportService: ReportService,
    private datePipe: DatePipe,
    private elementRef: ElementRef) {

  }
  ngAfterViewInit(): void {
  }

  public openPDF(): void {

    this.spinnerService.start();

    this.temp = true;

    setTimeout(() => {
      
      const fileWidth = 210;
      const fileLength = this.pdfFileLength;
      let doc = new jsPDF('p', 'mm', [fileWidth, fileLength], true);

      let pdfHeaderData = document.getElementById('pdfHeader');
      html2canvas(pdfHeaderData).then((canvas) => {
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 2, fileWidth, ((canvas.height * fileWidth) / canvas.width));

        let pdfBasicDetail = document.getElementById('basicDetail');
        html2canvas(pdfBasicDetail).then((pdfBasicDetailCanvas) => {
          doc.addImage(pdfBasicDetailCanvas.toDataURL('image/png'), 'PNG', 0, 15, fileWidth, ((pdfBasicDetailCanvas.height * fileWidth) / pdfBasicDetailCanvas.width));
          this.spinnerService.stop();
          doc.save('Report candidato.pdf');
          this.temp = false;
        });
      });
    }, 2000);

  }

  ngOnInit() {

    this.spinnerService.start();

    for (let i = 1; i < 100; i++) {
      this.guageGYRColorArray.push(this.rgbDoughNut(i));
      this.guageGYRDelimiterArray.push(i);
    }

    this.commonUtilService.translateLang("HRWE.REPORT.DETAIL");

    this.requestNumber = this.route.snapshot.paramMap.get('requestNumber');

    this.candidateUUID = this.route.snapshot.paramMap.get('uuid');

    this.map = new Map(XSD_MAPPER.map(i => [i.key, i.value]));

    this.configService.getValueByKey("LOGO").subscribe(data => {
      //console.log(data);
      this.logo = data.keyVal;
    });

    this.reportService.getCandidateDetail(this.requestNumber, this.candidateUUID).subscribe(data => {
      console.log(data);
      //console.log(data.cervedResult);

      this.data = data;

      if(this.data && this.data.cervedResult) {
        if (data.cervedResult['PersonCGS-/v1/score/person/standard']?.length) {
          try {
            const jsonObject = JSON.parse(data.cervedResult['PersonCGS-/v1/score/person/standard']);
            this.cervedPersonCGSscoreClass = jsonObject.scoreClass;
            this.needleValueScoreCGS = this.convertStringtoNumberAsRound(this.cervedPersonCGSscoreClass) * 10;
            this.pdfFileLength = this.pdfFileLength + 40;
            console.log(this.needleValueScoreCGS);
          } catch(error) {
            console.error("Failed to parse Person CGS:", error);
            this.cervedPersonCGSscoreClass = null;
          }
        }
        if (data.cervedResult['EstimationAdvanced-/v1/realEstateData/estimation/advanced']?.length) {
          try {
            this.estimationAdvance = JSON.parse(data.cervedResult['EstimationAdvanced-/v1/realEstateData/estimation/advanced']);
            //console.log(this.estimationAdvance);
            this.pdfFileLength = this.pdfFileLength + 40;
          } catch (error) {
            console.error("Failed to parse Estimation Advance:", error);
            this.estimationAdvance = null;
          }
        }
        if(data.cervedResult['CensusCellByAddress-/v1/score/census/section']) {
          try {
            this.cervedCensusCellByAddress = JSON.parse(data.cervedResult['CensusCellByAddress-/v1/score/census/section']);
            this.needleValueSD = this.convertStringtoNumberAsRound(this.cervedCensusCellByAddress.valore);
            //console.log(this.cervedCensusCellByAddress);
            this.pdfFileLength = this.pdfFileLength + 40;
          } catch (error) {
            console.error("Failed to parse Census Cell By Address:", error);
            this.cervedCensusCellByAddress = null;
          }
        }
        if(data.cervedResult['NegativeEventsFlags-/v1/rischi/negative/events/flags/ALL']) {
          try {
            this.negativeEventsFlags = JSON.parse(data.cervedResult['NegativeEventsFlags-/v1/rischi/negative/events/flags/ALL']);
            //console.log(this.negativeEventsFlags);
            this.negativeEventsFlags = this.negativeEventsFlags && this.negativeEventsFlags.people && this.negativeEventsFlags.people[0] ? this.negativeEventsFlags.people[0] : null;
            console.log(this.negativeEventsFlags);

            if (this.negativeEventsFlags.personalBankruptcies || this.negativeEventsFlags.prejudicialEvents || this.negativeEventsFlags.crisisEvents) {
              this.riskLevel = 'red';  // High risk
            } else if (this.negativeEventsFlags.protests || this.negativeEventsFlags.cigs) {
              this.riskLevel = 'yellow';  // Moderate risk
            } else {
              this.riskLevel = 'green';  // Low risk
            }
            this.pdfFileLength = this.pdfFileLength + 100;
          } catch (error) {
            console.error("Failed to parse Negative Events Flags:", error);
            this.negativeEventsFlags = null;
            this.riskLevel = '';
          }
        }
        if(data.cervedResult['NegativeEventsDetails-/v1/risks/negative/events']) {
          try {
            this.negativeEventsDetails = JSON.parse(data.cervedResult['NegativeEventsDetails-/v1/risks/negative/events']);
            this.negativeEventsDetails = this.negativeEventsDetails && this.negativeEventsDetails.people && this.negativeEventsDetails.people[0] ? this.negativeEventsDetails.people[0] : null;
            //console.log(this.negativeEventsDetails);
          } catch (error) {
            console.error("Failed to parse Negative Events Details:", error);
            this.negativeEventsDetails = null;
          }
        }
        if(data.cervedResult['Traversal-/v1/traversal/plus']) {
          try {
            this.traversal = JSON.parse(data.cervedResult['Traversal-/v1/traversal/plus']);
            //console.log(this.traversal);
            this.pdfFileLength = this.pdfFileLength + 40;
            this.societaDetails = this.extractSocietaDetailsFromTraversal(this.traversal.risultati);
          } catch (error) {
            console.error("Failed to parse Traversal:", error);
            this.traversal = null;
          }
        }
      }


      if (this.data && this.data.hrweResult && this.data.hrweResult.degradationScore && this.data.hrweResult.degradationScore !== '') {
        let bcVal = this.rgbDoughNut(Math.round(Number(this.data.hrweResult.degradationScore)));
        this.pieChartColors = [{
          backgroundColor: [bcVal]
        }];

      }

      if (this.data && this.data.hrweResult) {

        //this.needleValueSD = this.convertStringtoNumberAsRound(this.data.hrweResult.degradationScore);
        this.needleValueEN = this.getValueByStatus(this.data.hrweResult.relevanceNegativity);
        
        let hrWeScore: number = 0;
        let hrWeScoreString: string = '';
        let degradedScore: number = Number(this.data.hrweResult.degradationScore);
        let negativeEvent: string = this.data.hrweResult.relevanceNegativity;
        let stimaReddito: string = '';
        
        console.log("CRIF ");
        console.log(JSON.stringify(data.crifResult));

        console.log("CRIBIS ");
        console.log(JSON.stringify(data.cribisResult));

        console.log("data.hrweResult.averageIncomeProvinceIndex "+data.hrweResult.averageIncomeProvinceIndex);
        if (data.hrweResult.averageIncomeProvinceIndex < 1) {
          stimaReddito = 'inferiore';
        } else {
          stimaReddito = 'nessuno';
        }
        console.log("stimaReddito "+stimaReddito);

        let negativeEventValue: number = 0;
        
        console.log("data.hrweResult.degradationScore "+data.hrweResult.degradationScore);
        degradedScore = degradedScore / 100 * 45;
        console.log("degradedScore / 100 * 45 " +degradedScore);
        console.log("negativeEvent - data.hrweResult.relevanceNegativity val = "+data.hrweResult.relevanceNegativity);
        if (negativeEvent !== null && negativeEvent !== '') {
          if (negativeEvent.toLowerCase() === 'nessuno' || negativeEvent.toLowerCase() === 'nessuna') {
            negativeEventValue = 0;
          } else if (negativeEvent.toLowerCase() === 'basso' || negativeEvent.toLowerCase() === 'bassa') {
            negativeEventValue = 150;
          } else if (negativeEvent.toLowerCase() === 'medio' || negativeEvent.toLowerCase() === 'media') {
            negativeEventValue = 250;
          } else if (negativeEvent.toLowerCase() === 'alto' || negativeEvent.toLowerCase() === 'alta') {
            negativeEventValue = 450;
          }
        }
        console.log("negativeEventValue "+negativeEventValue);

        hrWeScore = negativeEventValue / 10;
        console.log("negativeEventValue / 10 "+hrWeScore);
        /* commented by LucaZ after call with Ludwig 02/11/2022
        hrWeScore = hrWeScore.valueOf() / 100;
        console.log("hrWeScore / 100 "+hrWeScore);
        hrWeScore = hrWeScore.valueOf() * 45;
        console.log("hrWeScore * 45 "+hrWeScore);*/
        hrWeScore = degradedScore + hrWeScore.valueOf();
        console.log("degradedScore + hrWeScore "+hrWeScore);
        
        if (stimaReddito === 'inferiore') {
          hrWeScore = +hrWeScore + + 10;
          console.log("stimaReddito is inferiore, so 10 added to hrwescore "+hrWeScore);
        }
        console.log(hrWeScore);

        /* cerved modification - SCORE HRWE = SCORE CGS *100  */
        hrWeScore = this.cervedPersonCGSscoreClass * 10;

        if (hrWeScore <= 20) { hrWeScoreString = "Molto Basso"; }
        else if (hrWeScore <= 20) { hrWeScoreString = "Molto Basso"; }
        else if (hrWeScore <= 40) { hrWeScoreString = "Basso"; }
        else if (hrWeScore <= 60) { hrWeScoreString = "Medio"; }
        else if (hrWeScore <= 80) { hrWeScoreString = "Alto"; }
        else if (hrWeScore <= 100) { hrWeScoreString = "Molto Alto"; }
        //else if (hrWeScore <= 100) { hrWeScoreString = "Errore"; }

        this.doughnutTextContent = hrWeScoreString;

        this.doughnutScore = Math.round(hrWeScore.valueOf());
        let bcVal = this.rgbDoughNut(Math.round(hrWeScore.valueOf()));
        this.pieChartColors = [{
          backgroundColor: [bcVal]
        }];

      }
      if(data && data.cribisResult && data.cribisResult.result){
        try {
          var objCribis = JSON.parse(data.cribisResult.result);
          this.prrObj = objCribis['s:Envelope']['s:Body']['GetReportByPFTaxCodeResponse']['BusinessReportDocument']['PRR']['NE'];
          console.log(JSON.stringify(this.prrObj));
        }
        catch (e: any) {
          console.log(e.message);
          this.prrObj = null;
        }
      }
      
      this.spinnerService.stop();
    });

  }

  convertToArray(obj) {
    let arr = [];
    if (Array.isArray(obj)) {
      arr = obj;
    } else {
      arr.push(obj);
    }
    return arr;
  }

  convertStringtoNumberAsRound(val) {
    return Math.round(Number(val));
  }

  goBack() {
    if (localStorage.getItem('candidate_redirect') === 'all') {
      localStorage.removeItem('candidate_redirect');
      this.router.navigate(['/report/candidate-list']);
    } else {
      this.router.navigate(['/report/detail/view/' + this.requestNumber]);
    }
  }

  getProvinceIndex(val) {
    let res = '';
    if (val) {
      let num = parseFloat(val);
      if (num < 1) {
        res = 'valore inferiore del valore provinciale';
        this.needleValueSR = 10;
      } else if (num > 1) {
        res = 'valore superiore al valore provinciale';
        this.needleValueSR = 90;
      } else if (num = 1) {
        res = 'valore uguale al valore provinciale';
        this.needleValueSR = 50;
      }
    }
    return res;
  }

  getCribisOptionValCheck(val) {
    let res = '';
    if (val) {
      if (Boolean(JSON.parse(val))) {
        res = 'SI';
      } else {
        res = 'NO';
      }
    }
    return res;
  }

  getCribisOptionValCheckPDF(val) {
    let res = '';
    if (val) {
      if (Boolean(JSON.parse(val))) {
        res = 'Rilevati';
      } else {
        res = 'Nessuna';
      }
    }
    return res;
  }

  getScoreDegradoText(score: number) {
    if (score <= 20) { return "Molto Basso"; }
    else if (score <= 40) { return "Basso"; }
    else if (score <= 60) { return "Medio"; }
    else if (score <= 80) { return "Alto"; }
    else if (score <= 100) { return "Molto Alto"; }
  }

  rgbDoughNut(val) {

    if (val > 100) {
      val = 100;
    }
    else if (val < 0) {
      val = 0;
    }

    var h = Math.floor((100 - val) * 120 / 100);
    var s = Math.abs(val - 50) / 50;
    var v = 1;

    var r, g, b;
    if (val <= 50) {
      r = Math.floor((255 * (val / 50))),
        g = 255,
        b = Math.floor((255 * (val / 50)));
    }
    else {
      r = 255,
        g = Math.floor((100 - val) / 50 * 255),
        b = Math.floor((100 - val) / 50 * 255);
    }
    if (val > 35 && val < 65) {
      b = 0;
    }

    return "rgb(" + r + "," + g + "," + b + ")";
  }

  getValueByStatus(val: string) {
    let score = 1;
    if(val !== undefined && val !== null && val !== ''){
      val = val.toLowerCase();
      if(val === "molto basso" || val === "molto bassa"){
        score = 20;
      } else if(val === "basso" || val === "bassa"){
        score = 40;
      } else if(val === "medio" || val === "media") {
        score = 60;
      } else if(val === "alto" || val === "alta"){
        score = 80;
      } else if(val === "molto alto" || val === "molto alta") {
        score = 100;
      }
    }
    return score;
  }

  convertBooleanToString(val) {
    const res = val === true ? 'Si' : val === false ? 'No' : '-';
    return res;
  }

  getStimaRedditoValue(val) {
    if(!val) {
      return '-';
    }
    return parseFloat(((val / 360) * 3.5).toFixed(2));
  }

  extractSocietaDetailsFromTraversal(risultati: Risultati): any[] {
    if (!risultati || !risultati.dati) {
      return [];
    }
  
    const nodi = risultati.dati.nodi || [];
    const relazioni = risultati.dati.relazioni || [];
  
    const societa = nodi.filter(nodo => nodo.tipoSoggetto === "societa");
  
    return societa.map(societaNode => {
      const proprieta = societaNode.proprieta || {};
  
      const societaDetails = {
        idSoggetto: societaNode.idSoggetto || null,
        codiceFiscale: societaNode.cdFiscale || null,
        partitaIva: societaNode.piva || null,
        flgCessata: proprieta.flgCessata || null,
        flgFiduciaria: proprieta.flgFiduciaria || null,
        flgOperativa: proprieta.flgOperativa || null,
        dtIscrizioneRea: proprieta.dtIscrizioneRea || null,
        flgCapogruppo: proprieta.flgCapogruppo || null,
        dimensione: proprieta.dimensione || null,
        flgStartup: proprieta.flgStartup || null,
        indirizzo: proprieta.indirizzo || null,
        denominazione: proprieta.denominazione || null,
        dipendenti: proprieta.dipendenti || null,
        flgInProcedure: proprieta.flgInProcedure || null,
        dtInizioAttivita: proprieta.dtInizioAttivita || null,
        iscrizione: proprieta.iscrizione || null,
        relazioni: relazioni
          .filter(rel => rel.nodoFine === societaNode.id)
          .map(rel => ({
            id: rel.id || null,
            tipo: rel.tipo || null,
            nodoPartenza: rel.nodoPartenza || null,
            nodoFine: rel.nodoFine || null,
            valoreTotalePartecipazione: rel.proprieta?.tot_valore_eu || null,
            percentualePartecipazione: rel.proprieta?.tot_perc || null,
            legame: rel.proprieta?.legame_partecipazione || null,
            dataInizioRelazione: rel.proprieta?.dt_inizio || null,
            dataModifica: rel.proprieta?.dt_modifica || null
          }))
      };
  
      return societaDetails;
    });
  }
}  

interface Nodo {
  id: string;
  idSoggetto: number;
  etichette: string[];
  tipoSoggetto: string;
  cdFiscale: string;
  piva?: string;
  proprieta: {
    [key: string]: string | number | boolean | undefined;
  };
}

interface Relazione {
  id: string;
  tipo: string;
  nodoPartenza: string;
  nodoFine: string;
  proprieta: {
    tot_valore_eu: number;
    tot_perc: number;
    legame_partecipazione: string;
    dt_inizio: string;
    dt_modifica: string;
  };
}

interface Risultati {
  dati: {
    nodi: Nodo[];
    relazioni: Relazione[];
  };
}